// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { brewcontrolNodeId } from './BrewcontrolNode';
import { z } from 'zod';
export const brewcontrolWorkspaceId = (z.number());
export const brewcontrolWorkspace = z.object({
    id: brewcontrolWorkspaceId,
    node_id: brewcontrolNodeId,
    bc_workspace_id: z.number(),
    display_name: z.string().nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    deleted_at: z.date().nullable(),
});
export const brewcontrolWorkspaceInitializer = z.object({
    id: brewcontrolWorkspaceId.optional(),
    node_id: brewcontrolNodeId,
    bc_workspace_id: z.number(),
    display_name: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
});
export const brewcontrolWorkspaceMutator = z.object({
    id: brewcontrolWorkspaceId.optional(),
    node_id: brewcontrolNodeId.optional(),
    bc_workspace_id: z.number().optional(),
    display_name: z.string().optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    deleted_at: z.date().optional().nullable(),
});
//# sourceMappingURL=BrewcontrolWorkspace.js.map